import { DefaultState } from 'store/types';
import { OptionRequiredOptionalNotSupportedStatuses } from 'store/reducers/reservation-provider/types';

export const ADD_EDIT_ROOM_REQUEST = 'ADD_EDIT_ROOM_REQUEST';
export const ADD_EDIT_ROOM_SUCCESS = 'ADD_EDIT_ROOM_SUCCESS';
export const ADD_EDIT_ROOM_FAILURE = 'ADD_EDIT_ROOM_FAILURE';

export interface AddEditRoom {
  fromDate: Date | null;
  toDate: Date | null;
  typeId: string;
  reservationId: string;
  totalRate: number | null;
  occupancy: number | null;
  corporateClientName: string;
  reservationProviderId: string;
  clcRequestNumber?: string;
  requestNumberRequired?: OptionRequiredOptionalNotSupportedStatuses;
  lodgingPolicy?: string;
};

export interface AddEditRoomParams {
  id?: string;
  lodgingOptionId?: string;
  typeId: string;
  totalRate: number;
  reservationId: string;
  fromDate: string;
  toDate: string;
  occupancy: number;
  corporateClientName: string;
  reservationProviderId: string;
  clcRequestNumber?: string;
  requestNumberRequired?: OptionRequiredOptionalNotSupportedStatuses;
  lodgingPolicy?: string;
  doNotSendToAssociate?: boolean;
  doNotSendToCLC?: boolean;
};

export interface AddEditRoomData {
  id?: string;
};

export type AddEditRoomState = DefaultState & {
  contents?: AddEditRoomData;
};

interface AddEditRoomDataRequest {
  type: typeof ADD_EDIT_ROOM_REQUEST;
};

interface AddEditRoomDataSuccess {
  type: typeof ADD_EDIT_ROOM_SUCCESS,
  contents: AddEditRoomData;
}

interface AddEditRoomDataFailure {
  type: typeof ADD_EDIT_ROOM_FAILURE;
}

export type AddEditRoomActionTypes = AddEditRoomDataRequest | AddEditRoomDataSuccess | AddEditRoomDataFailure;